var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"widget-emojile w-[100px] h-[30px] u-center",attrs:{"href":"/emojile"}},[_c('OImage',{staticClass:"w-[74px] h-[26px]",attrs:{"loading":"lazy","src":"/images/emojile.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }